<script>
import BlankHeader from '@/components/templates/blank-header.vue'
import FooterComponent from '@/components/templates/footer.vue'

export default {
  components: {
    BlankHeader,
    FooterComponent
  }
};
</script>

<template>
  <div>
    <BlankHeader/>
    <div class="main-page account-pages">
      <div class="container-fluid">
        <slot />
      </div>
    </div>
    <FooterComponent/>
  </div>
</template>